"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = createClient;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _regenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _common = _interopRequireDefault(require("../common"));
var _app = _interopRequireDefault(require("./app"));
var _history = _interopRequireDefault(require("./history"));
var _middlewares = _interopRequireDefault(require("./middlewares"));
var _config = _interopRequireDefault(require("./config"));
var _utils = require("../common/utils");
var _excluded = ["disableUseDefaultMiddlewares", "styles"];
function createClient() {
  var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var wapp = p.wapp || (0, _common["default"])(p);
  var _createConfig = (0, _config["default"])(p),
    config = _createConfig.config;
  var clientConfig = config.client || {};
  var _clientConfig$disable = clientConfig.disableUseDefaultMiddlewares,
    disableUseDefaultMiddlewares = _clientConfig$disable === void 0 ? false : _clientConfig$disable,
    _clientConfig$styles = clientConfig.styles,
    styles = _clientConfig$styles === void 0 ? {} : _clientConfig$styles,
    rest = (0, _objectWithoutProperties2["default"])(clientConfig, _excluded);
  var _styles$disableClearM = styles.disableClearMainStyle,
    disableClearMainStyle = _styles$disableClearM === void 0 ? false : _styles$disableClearM;
  var defaultConfig = Object.create(Object.prototype, {
    disableUseDefaultMiddlewares: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: disableUseDefaultMiddlewares
    })
  });
  (0, _utils.mergeProperties)(defaultConfig, wapp.config);
  (0, _utils.mergeProperties)(defaultConfig, rest);
  var app = (0, _app["default"])({
    wapp: wapp
  });
  var history = (0, _history["default"])({
    wapp: wapp
  });
  function defaultListen() {
    wapplrClient.close();
    wapplrClient.history.listen(function (_ref) {
      var action = _ref.action,
        location = _ref.location,
        state = _ref.state;
      wapplrClient.app({
        history: {
          action: action,
          location: location,
          state: state
        }
      });
    });
    wapplrClient.app({
      history: {
        action: "POP",
        location: {
          pathname: window.location.pathname,
          search: window.location.search,
          hash: window.location.hash
        },
        state: window.history.state || {
          key: "initial"
        }
      }
    }, {}, function out() {
      var globals = wapp.globals;
      var WAPP = globals.WAPP;
      if (!disableClearMainStyle) {
        setTimeout(function () {
          var elem = document.getElementById("css_" + WAPP);
          if (elem) {
            elem.parentNode.removeChild(elem);
          }
        }, 2000);
      }
    });
  }
  function defaultClose() {
    wapplrClient.history.close();
  }
  var defaultMiddlewares = (0, _middlewares["default"])((0, _objectSpread2["default"])({
    wapp: wapp
  }, p));
  var wapplrClient = Object.create(Object.prototype, {
    config: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      writable: false,
      value: defaultConfig
    }),
    listen: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: defaultListen
    }),
    close: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: defaultClose
    }),
    history: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: history
    }),
    app: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: app
    }),
    middlewares: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: defaultMiddlewares
    })
  });
  Object.defineProperty(wapplrClient, "wapp", (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
    writable: false,
    enumerable: false,
    value: wapp
  }));
  Object.defineProperty(wapp, "client", (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
    value: wapplrClient
  }));
  app.use(/*#__PURE__*/function () {
    var _defaultMiddlewaresWrapper = (0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regenerator2["default"])().m(function _callee3(req, res, out) {
      var _next, middlewares, index;
      return (0, _regenerator2["default"])().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            if (wapplrClient.config.disableUseDefaultMiddlewares) {
              _context3.n = 2;
              break;
            }
            _next = /*#__PURE__*/function () {
              var _ref2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regenerator2["default"])().m(function _callee2(err) {
                var func, defaultArgs, args, _t;
                return (0, _regenerator2["default"])().w(function (_context2) {
                  while (1) switch (_context2.p = _context2.n) {
                    case 0:
                      if (!middlewares[index]) {
                        _context2.n = 5;
                        break;
                      }
                      func = middlewares[index];
                      index = index + 1;
                      defaultArgs = [req, res, err ? /*#__PURE__*/(0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regenerator2["default"])().m(function _callee() {
                        return (0, _regenerator2["default"])().w(function (_context) {
                          while (1) switch (_context.n) {
                            case 0:
                              _context.n = 1;
                              return _next(err);
                            case 1:
                              return _context.a(2);
                          }
                        }, _callee);
                      })) : _next];
                      args = func.length === 4 && err ? [err].concat(defaultArgs) : defaultArgs;
                      _context2.p = 1;
                      _context2.n = 2;
                      return func.apply(void 0, (0, _toConsumableArray2["default"])(args));
                    case 2:
                      return _context2.a(2, _context2.v);
                    case 3:
                      _context2.p = 3;
                      _t = _context2.v;
                      res.wappResponse.status(500, _t);
                      _context2.n = 4;
                      return _next(_t);
                    case 4:
                      return _context2.a(2, _context2.v);
                    case 5:
                      if (!(typeof out === "function")) {
                        _context2.n = 6;
                        break;
                      }
                      index = 0;
                      return _context2.a(2, out(err));
                    case 6:
                      return _context2.a(2, null);
                  }
                }, _callee2, null, [[1, 3]]);
              }));
              return function next(_x4) {
                return _ref2.apply(this, arguments);
              };
            }();
            middlewares = Object.keys(wapplrClient.middlewares).map(function (key) {
              return wapplrClient.middlewares[key];
            });
            index = 0;
            _context3.n = 1;
            return _next();
          case 1:
            return _context3.a(2, _context3.v);
          case 2:
            _context3.n = 3;
            return out();
          case 3:
            return _context3.a(2, _context3.v);
        }
      }, _callee3);
    }));
    function defaultMiddlewaresWrapper(_x, _x2, _x3) {
      return _defaultMiddlewaresWrapper.apply(this, arguments);
    }
    return defaultMiddlewaresWrapper;
  }());
  return wapp;
}